import React from "react"
import { Container, Form } from "../components"

const tabs = [
  {
    title: "Property Management",
    category: "propertyManagement",
  },
  {
    title: "Leasing",
    category: "leasing",
  },
  {
    title: "Tenants",
    category: "tenants",
  },
  {
    title: "Maintenance",
    category: "maintenance",
  },
  {
    title: "Accounting",
    category: "accounting",
  },
  {
    title: "ERP",
    category: "erp",
  },
  {
    title: "Tasks",
    category: "tasks",
  },
  {
    title: "Vendors",
    category: "vendors",
  },
  {
    title: "Security",
    category: "security",
  },
  {
    title: "Customer Support",
    category: "customerSupport",
  },
]

const Contact = () => {
  return (
    <div className="w-full pt-20 lg:h-screen bg-simpleBG bg-cover bg-no-repeat border-[0] border-transparent">
      <Form />
    </div>
  )
}

export default Contact
